import React from 'react';

function IconSlackSvg() {
  return (
    <svg
      width="94"
      height="94"
      viewBox="0 0 94 94"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M56.7917 39.1663C53.5409 39.1663 50.9167 36.5422 50.9167 33.2913V13.708C50.9167 10.4572 53.5409 7.83301 56.7917 7.83301C60.0425 7.83301 62.6667 10.4572 62.6667 13.708V33.2913C62.6667 36.5422 60.0425 39.1663 56.7917 39.1663Z"
        stroke="#800020"
        strokeWidth="7.83333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M80.2917 39.167H74.4167V33.292C74.4167 30.0412 77.0409 27.417 80.2917 27.417C83.5425 27.417 86.1667 30.0412 86.1667 33.292C86.1667 36.5428 83.5425 39.167 80.2917 39.167Z"
        stroke="#800020"
        strokeWidth="7.83333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.2083 54.833C40.4591 54.833 43.0833 57.4572 43.0833 60.708V80.2913C43.0833 83.5422 40.4591 86.1663 37.2083 86.1663C33.9575 86.1663 31.3333 83.5422 31.3333 80.2913V60.708C31.3333 57.4572 33.9575 54.833 37.2083 54.833Z"
        stroke="#800020"
        strokeWidth="7.83333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.7083 54.833H19.5833V60.708C19.5833 63.9588 16.9591 66.583 13.7083 66.583C10.4575 66.583 7.83331 63.9588 7.83331 60.708C7.83331 57.4572 10.4575 54.833 13.7083 54.833Z"
        stroke="#800020"
        strokeWidth="7.83333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M54.8333 56.792C54.8333 53.5412 57.4575 50.917 60.7083 50.917H80.2916C83.5425 50.917 86.1666 53.5412 86.1666 56.792C86.1666 60.0428 83.5425 62.667 80.2916 62.667H60.7083C57.4575 62.667 54.8333 60.0428 54.8333 56.792Z"
        stroke="#800020"
        strokeWidth="7.83333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M60.7083 74.417H54.8333V80.292C54.8333 83.5428 57.4575 86.167 60.7083 86.167C63.9591 86.167 66.5833 83.5428 66.5833 80.292C66.5833 77.0412 63.9591 74.417 60.7083 74.417Z"
        stroke="#800020"
        strokeWidth="7.83333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.1666 37.208C39.1666 33.9572 36.5425 31.333 33.2916 31.333H13.7083C10.4575 31.333 7.83331 33.9572 7.83331 37.208C7.83331 40.4588 10.4575 43.083 13.7083 43.083H33.2916C36.5425 43.083 39.1666 40.4588 39.1666 37.208Z"
        stroke="#800020"
        strokeWidth="7.83333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.2917 19.583H39.1667V13.708C39.1667 10.4572 36.5425 7.83301 33.2917 7.83301C30.0409 7.83301 27.4167 10.4572 27.4167 13.708C27.4167 16.9588 30.0409 19.583 33.2917 19.583Z"
        stroke="#800020"
        strokeWidth="7.83333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default IconSlackSvg;
